<mat-sidenav-container class="mt-4 example-container">
  <mat-sidenav #sidenav class="example-sidenav bg-slate-100" mode="over" position="end">
    <div class="ps-2 ms-2 d-flex flex-column">
      <app-filtro-storico-deleghe
        (searchEvent)="search($event)"></app-filtro-storico-deleghe>
    </div>
  </mat-sidenav>
  <mat-sidenav-content class="example-content">
    <div class="rounded bg-white shadow-sm mt-2 mb-4 pb-3 pt-4 px-4 w-100">
      <div class="row g-3 mb-3">
        <h5 class="fw-bold">Gestione deleghe</h5>
        <div class="col-6">
          <button type="button" class="btn btn-outline-primary fw-semibold" title="Filtra" (click)="sidenav.toggle()">
            <i class="bi bi-funnel-fill me-1"></i>
            Filtra
          </button>
          @if (deleghe.length > 0) {
          <button (click)="exportDataToExcel()" type="button" class="btn btn-outline-primary ms-3 fw-semibold">
            <i class="bi bi-file-earmark-spreadsheet-fill me-1"></i>
            Esporta in Excel
          </button>
          }
        </div>
        <div class="col-6 d-flex justify-content-end">
          <button type="button" class="btn btn-outline-primary fw-semibold me-3" (click)="goToHomepage()">
            <i class="bi bi-arrow-left me-1"></i>
            Torna alla homepage
          </button>
          <button type="button" class="btn btn-primary fw-semibold" (click)="openNuovaDelega()">
            <i class="bi bi-plus-lg me-1"></i>
            Inserisci delega
          </button>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12">
          @if (deleghe.length > 0) {
          <app-tabella-storico-deleghe
            #tabellaComponent
            [dataSource]="deleghe"
            [elencoCount]="delegheCount"
            [idAnagraficaTimesheetCorrente]="anagraficaTimesheet?.id ?? 0"
            (disattivaEvent)="disattivaDelega($event)"
            ></app-tabella-storico-deleghe>
          } @else {
          <p class="w-100 text-center">Nessuna delega presente</p>
          }
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
